import React, { useEffect, useRef, useState } from 'react';
import "./paginationhoc.scss"



const PaginationBox = ({ totalrecord,onclickBox ,currentIndex =1}) => {
    const [currentindex, setcurrentindex] = useState(currentIndex)
    const [pages, setpages] = useState(Array.from({ length: Math.ceil(totalrecord / 6) }, (_, i) => i + 1))
    useEffect(() => {
        let pageList = [];
        if (Number(totalrecord) > 0) {
            const left = currentIndex == totalrecord ? currentIndex - 4 : currentIndex - 2;
            const right = currentIndex > 2 ? currentIndex + 2 : currentIndex + 4;

            for (let i = 1; i <= totalrecord;) {
                if (i === 1 || i === totalrecord || (i >= left && i <= right)) {
                    pageList.push(i);
                } else {
                    if (pageList[pageList.length - 1] !== null) {
                        pageList.push(null);
                    }
                }
                i++
            }
        }
        setcurrentindex(currentIndex)
        setpages([...pageList])
    }, [totalrecord, currentIndex])




    return (
        <div className={"paginationhoc"} >
            <div className='pagination'>
                {pages.map((page, index) => (
                    <div
                        role={typeof page === 'number' ? "button" : "none"}
                        className={`page-button ${currentindex === page ? 'active' : ''}  ${page !== '⋯' ? 'borderbox' : 'dotbox'}`}
                        onClick={() => {
                            if (typeof page === 'number') {
                                setcurrentindex(page)
                                onclickBox(page)
                            }
                        }}
                    >{page == null? <div className="page-dots">
                    <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/dots.svg`} />
                </div>:page}</div>
                ))}
            </div>
        </div>
    );
};

export default PaginationBox;

